export enum statusEnum {
  Active = "Active",
  Inactive = "Inactive",
  Archived = "Archived",
  Deleted = "Deleted",
  Draft = "Draft",
}

//TODO: refactor below to use enum
export type Status = "Active" | "Inactive" | "Archived" | "Deleted" | "Draft";
export type StatusIndicatorProps = {
  status?: Status;
};

export const getStatusTextColorClass = (statusVal?: Status) => {
  switch (statusVal) {
    case statusEnum.Inactive:
      return "colorHighlightGray";
    case statusEnum.Archived:
      return "colorHighlightYellow";
    default:
      return "colorHighlightSuccess";
  }
};

export const getStatusIndicatorProps = ({ status }: StatusIndicatorProps) => {
  return {
    text: status || statusEnum.Active,
  };
};
